
const Title = ({title, maxWidth}) => <p style={{maxWidth: `${maxWidth}px`}}> {title}</p>
export default Title;
